
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/signup",
      function () {
        return require("private-next-pages/account/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/signup"])
      });
    }
  